export default "__VITE_ASSET__Dcq2AxOe__"